import { defineRouting } from 'next-intl/routing';
import { defaultLocale, locales } from './config';

export const routing = defineRouting({
    locales,
    defaultLocale,
    localePrefix: 'as-needed',
    localeCookie: false,
    // URL is the single source of truth for locale. Without this, an unprefixed
    // path (e.g. /start = default de) is resolved via Accept-Language, so switching
    // EN→DE redirects /start→/en/start on any en-preferring browser (Safari bug).
    // Disabling detection keeps pages CDN-cacheable (no NEXT_LOCALE cookie needed).
    localeDetection: false,
});
